import { render } from "./Planes.vue?vue&type=template&id=5626447e"
const script = {}

import exportComponent from "D:\\GIT\\DevOps\\Planner\\FRONT_Planner\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__